export const IMPLEMENTATION_GUIDE_API_BASE_URL =
  "/api/v3/implementation-guide/";
export const SUBTITLE_FOR_INCOMPLETE_FORMS =
  "To ensure your district is set up for success we have some implementation questions that will need to be addressed.";
export const SUBTITLE_FOR_ALL_FORMS_COMPLETED =
  "Ensure success with Newsela by using the checklist and resources below.";
export const DOWNLOAD_PDF_LABEL_FOR_INCOMPLETE_FORMS = "Download preview PDF";
export const DOWNLOAD_PDF_LABEL_FOR_ALL_FORMS_COMPLETED =
  "Download admin quick start PDF";

export const CHIRON_BASE_URL = "/chiron/implementation-guide/district";
export const ADMIN_BASE_URL = "/admin/implementation-guide";

export const PDF_OUTPUT_MARGIN = 40;
